import React, { useEffect, useState, useRef } from 'react';
import TestingSection from './TestingSection';
import { useNavigate } from 'react-router-dom';
import { Container } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { Shield } from 'lucide-react';

function InterviewPrep() {
  const navigate = useNavigate();
  const [isValidated, setIsValidated] = useState(false);
  const hasCheckedAccess = useRef(false);

  useEffect(() => {
    // Only check once on mount
    if (hasCheckedAccess.current) return;
    hasCheckedAccess.current = true;
    
    const isValidAccess = sessionStorage.getItem("isValidAccess") === "true";
  
    if (!isValidAccess) {
      navigate('/user-home');
    } else {
      // Mark as validated for this session, then remove the flag
      setIsValidated(true);
      sessionStorage.removeItem("isValidAccess");
    }
  }, [navigate]);

  // Show nothing until validation is complete
  if (!isValidated) return null;

  return (
    <div className="min-h-screen w-full bg-background flex flex-col">
      {/* Compact header - no navbar during interview setup for focus */}
      <div className="relative w-full py-3 md:py-4 bg-gradient-to-r from-primary/10 via-primary/5 to-background border-b">
        <Container>
          <div className="flex items-center justify-center gap-3">
            <div className="w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center">
              <Shield className="w-4 h-4 text-primary" />
            </div>
            <div>
              <Heading level="h1" className="text-xl md:text-2xl font-bold">Interview Setup</Heading>
              <Text className="text-xs text-muted-foreground">
                Complete the setup below to start your interview
              </Text>
            </div>
          </div>
        </Container>
      </div>
      <div className="flex-1">
        <TestingSection />
      </div>
    </div>
  );
}

export default InterviewPrep;